import axios from 'axios'
import urlGenerator from './url-generator'
import { property } from 'lodash'
import createRequestConfig from './create-request-config'

const fetch = () => {
    return axios.get(urlGenerator.interests(), createRequestConfig()).then(property('data'))
}

export default {
    fetch,
}